// extracted by mini-css-extract-plugin
export default {"textArea":"FormItems_textArea__6F1DU","inputUrl":"FormItems_inputUrl__sfZ9J"};